import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const ConfigContext = createContext(null);

export const useConfig = () => useContext(ConfigContext);

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/config");
      setConfig(data);
      applySideEffects(data);
    } catch (e) {
      console.error("Failed to load config", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <ConfigContext.Provider value={{ config, setConfig, reload: load, loading }}>
      {children}
    </ConfigContext.Provider>
  );
}

function applySideEffects(cfg) {
  if (!cfg) return;
  if (cfg.accent_color) {
    document.documentElement.style.setProperty("--accent", cfg.accent_color);
    const rgb = hexToRgb(cfg.accent_color);
    if (rgb) {
      document.documentElement.style.setProperty(
        "--accent-glow",
        `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.5)`
      );
    }
  }
  if (cfg.favicon_url) {
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = cfg.favicon_url;
  }
}

function hexToRgb(hex) {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return m
    ? { r: parseInt(m[1], 16), g: parseInt(m[2], 16), b: parseInt(m[3], 16) }
    : null;
}
